import axios, { AxiosPromise } from 'axios';

const sendMail = (
  to: string,
  from: string,
  subject: string,
  message: string
): AxiosPromise => {
  // Pantheon serves public/api/email.php; local `npm run dev` proxies to Express.
  return axios.post('/api/email.php', { to, from, subject, message });
};

export { sendMail };
